import React, { memo } from "react";

import { Stations } from "Components/Stations/Stations";

import { StationsController } from "./Stations.controller";
import { StationsLoader } from "./Stations.loader";

export const StationsPage = memo(() => {
  return (
    <StationsLoader>
      <StationsController />
      <Stations />
    </StationsLoader>
  );
});
